(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-countdown')) {
    class AnnouncementCountdown extends HTMLElement {
      connectedCallback() {
        this.endTime = Date.parse(this.dataset.end)
        if (Number.isNaN(this.endTime)) {
          this.hidden = true
          return
        }

        this.showSeconds = this.dataset.showSeconds !== 'false'
        this.dayOne = this.dataset.dayOne
        this.dayOther = this.dataset.dayOther
        this.update()
        if (this.endTime > Date.now()) {
          this.interval = window.setInterval(() => this.update(), this.showSeconds ? 1000 : 30000)
        }
      }

      disconnectedCallback() {
        window.clearInterval(this.interval)
      }

      update() {
        const remaining = Math.max(0, this.endTime - Date.now())

        if (remaining === 0) {
          window.clearInterval(this.interval)
          if (this.dataset.hideWhenExpired === 'true') {
            this.hidden = true
          } else {
            this.textContent = this.dataset.expiredText
          }
          return
        }

        const totalSeconds = Math.floor(remaining / 1000)
        const days = Math.floor(totalSeconds / 86400)
        const hours = Math.floor((totalSeconds % 86400) / 3600)
        const minutes = Math.floor((totalSeconds % 3600) / 60)
        const seconds = totalSeconds % 60
        const format = (value) => String(value).padStart(2, '0')

        this.querySelector('[data-countdown-days]').textContent = String(days)
        this.querySelector('[data-countdown-day-label]').textContent = days === 1 ? this.dayOne : this.dayOther
        this.querySelector('[data-countdown-hours]').textContent = format(hours)
        this.querySelector('[data-countdown-minutes]').textContent = format(minutes)
        this.querySelector('[data-countdown-seconds]').textContent = format(seconds)
      }
    }

    customElements.define('announcement-countdown', AnnouncementCountdown)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const setWsProductImageMode = (mode) => {
    const nextMode = mode === 'worn' ? 'worn' : 'main';
    document.documentElement.setAttribute('data-ws-product-image-mode', nextMode);
    document.querySelectorAll('[data-ws-image-toggle]').forEach((button) => {
      const isActive = button.dataset.wsImageToggle === nextMode;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
    document.querySelectorAll('[data-ws-image-cycle]').forEach((button) => {
      button.dataset.wsImageCycleCurrent = nextMode;
      button.setAttribute('aria-pressed', String(nextMode === 'worn'));
    });
  };

  document.addEventListener('click', (event) => {
    const cycleButton = event.target.closest('[data-ws-image-cycle]');
    if (cycleButton) {
      const currentMode = cycleButton.dataset.wsImageCycleCurrent === 'worn' ? 'worn' : 'main';
      setWsProductImageMode(currentMode === 'worn' ? 'main' : 'worn');
      return;
    }

    const button = event.target.closest('[data-ws-image-toggle]');
    if (button) {
      setWsProductImageMode(button.dataset.wsImageToggle);
    }
  });

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      setWsProductImageMode('main');
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
  const initializeTrustpilotCarousel = (root) => {
    if (root.dataset.wsTrustpilotReady === 'true') return

    const track = root.querySelector('[data-ws-trustpilot-track]')
    const controls = root.querySelector('[data-ws-trustpilot-controls]')
    const previous = root.querySelector('[data-ws-trustpilot-previous]')
    const next = root.querySelector('[data-ws-trustpilot-next]')
    if (!track || !controls || !previous || !next) return

    root.dataset.wsTrustpilotReady = 'true'

    const updateControls = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth)
      controls.hidden = maximum < 2
      previous.disabled = track.scrollLeft <= 1
      next.disabled = track.scrollLeft >= maximum - 1
    }

    const move = (direction) => {
      const card = track.querySelector('.ws-trustpilot__review')
      if (!card) return
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: reducedMotion ? 'auto' : 'smooth',
      })
    }

    previous.addEventListener('click', () => move(-1))
    next.addEventListener('click', () => move(1))
    track.addEventListener('scroll', updateControls, { passive: true })
    new ResizeObserver(updateControls).observe(track)
    updateControls()
  }

  document.querySelectorAll('[data-ws-trustpilot-carousel]').forEach(initializeTrustpilotCarousel)
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ws-trustpilot-carousel]').forEach(initializeTrustpilotCarousel)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-carousel')) {
    customElements.define(
      'ugc-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-ugc-viewport]')
          this.track = this.querySelector('.ws-ugc__track')
          this.cards = [...this.querySelectorAll('[data-ugc-card]')]
          this.previousButton = this.querySelector('[data-ugc-previous]')
          this.nextButton = this.querySelector('[data-ugc-next]')
          this.autoplayEnabled = this.dataset.autoplay === 'true'
          this.speed = Number(this.dataset.speed) || 28
          this.swipeMomentum = Number(this.dataset.swipeMomentum) || 450
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          this.pauseReasons = new Set(['offscreen'])
          this.position = 0

          if (this.querySelector('[data-ugc-video]')) {
            this.setupMixedMedia()
            return
          }

          if (!this.viewport || !this.track || this.cards.length < 2) return

          this.previousButton?.addEventListener('click', () => this.move(-1))
          this.nextButton?.addEventListener('click', () => this.move(1))
          this.addEventListener('focusin', () => this.pause('focus'))
          this.addEventListener('focusout', () => this.resume('focus'))
          this.viewport.addEventListener('pointerdown', this.handlePointerDown)
          this.viewport.addEventListener('pointermove', this.handlePointerMove)
          this.viewport.addEventListener('pointerup', this.handlePointerEnd)
          this.viewport.addEventListener('pointercancel', this.handlePointerEnd)
          this.viewport.addEventListener('dragstart', this.preventNativeDrag)
          this.viewport.addEventListener('click', this.preventClickAfterDrag, true)
          this.viewport.addEventListener('keydown', this.handleKeyDown)
          document.addEventListener('visibilitychange', this.handleVisibility)
          this.createLoop()
          this.setupDeferredImages()
          this.setupVisibilityObserver()
          this.resizeObserver = new ResizeObserver(() => this.measureLoop())
          this.resizeObserver.observe(this.viewport)
          this.measureLoop()
          this.start()
        }

        disconnectedCallback() {
          this.stopFlow?.()
          window.clearTimeout(this.flowResumeTimer)
          this.flowObserver?.disconnect()
          this.mediaAbort?.abort()
          this.videoObserver?.disconnect()
          this.querySelectorAll('video').forEach((video) => video.pause())
          this.querySelectorAll('[data-ugc-flow-clone]').forEach((card) => card.remove())
          this.stop()
          this.momentumAnimation?.cancel()
          window.clearTimeout(this.resumeTimer)
          window.clearTimeout(this.interactionResumeTimer)
          this.resizeObserver?.disconnect()
          this.deferredImageObserver?.disconnect()
          this.visibilityObserver?.disconnect()
          document.removeEventListener('visibilitychange', this.handleVisibility)
          this.viewport?.removeEventListener('pointerdown', this.handlePointerDown)
          this.viewport?.removeEventListener('pointermove', this.handlePointerMove)
          this.viewport?.removeEventListener('pointerup', this.handlePointerEnd)
          this.viewport?.removeEventListener('pointercancel', this.handlePointerEnd)
          this.viewport?.removeEventListener('dragstart', this.preventNativeDrag)
          this.viewport?.removeEventListener('click', this.preventClickAfterDrag, true)
          this.viewport?.removeEventListener('keydown', this.handleKeyDown)
        }

        handleVisibility = () => {
          if (document.hidden) this.pause('visibility')
          else this.resume('visibility')
        }

        setupMixedMedia() {
          this.classList.add('ws-ugc--mixed')
          this.mediaAbort = new AbortController()
          const { signal } = this.mediaAbort
          this.ensureFlowCards()
          this.setupDeferredImages()
          this.visibleVideoCards = new Set()
          this.videoAutoplay = this.dataset.videoAutoplay === 'true' && !this.reducedMotion && !navigator.connection?.saveData
          this.classList.toggle('ws-ugc--video-autoplay', this.videoAutoplay)
          this.setupMixedDragging(signal)
          const updateButtons = () => {
            if (this.flowStride) {
              const stride = this.step()
              if (Math.abs(stride - this.flowStride) > 0.1) {
                this.ensureFlowCards()
                this.flowStride = stride
                this.flowPosition = this.viewport.scrollLeft
                if (!this.flowInteracting) this.normalizeFlow()
              }
            }
            if (this.previousButton) this.previousButton.disabled = this.viewport.scrollLeft < 2
            if (this.nextButton) this.nextButton.disabled = this.viewport.scrollLeft + this.viewport.clientWidth >= this.viewport.scrollWidth - 2
          }
          const move = (direction) => {
            const stride = this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0)
            this.viewport.scrollBy({ left: direction * stride, behavior: this.reducedMotion ? 'instant' : 'smooth' })
          }
          this.previousButton?.addEventListener('click', () => move(-1), { signal })
          this.nextButton?.addEventListener('click', () => move(1), { signal })
          this.viewport.addEventListener('scroll', updateButtons, { passive: true, signal })
          this.viewport.addEventListener('keydown', (event) => {
            if (event.target.tagName === 'VIDEO') return
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
            event.preventDefault()
            move(event.key === 'ArrowLeft' ? -1 : 1)
          }, { signal })
          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-ugc-play]')
            if (!button) return
            const card = button.closest('[data-ugc-video]')
            this.playCard(card, button, false)
          }, { signal })
          const resumeVisible = () => {
            if (!this.videoAutoplay || document.hidden) return
            this.visibleVideoCards.forEach((card) => {
              this.playCard(card, card.querySelector('[data-ugc-play]'), true)
            })
          }
          const pauseAll = () => this.querySelectorAll('video').forEach((video) => video.pause())
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) pauseAll()
            else resumeVisible()
          }, { signal })
          window.addEventListener('pagehide', pauseAll, { signal })
          window.addEventListener('pageshow', resumeVisible, { signal })
          this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach(({ target, intersectionRatio }) => {
              if (intersectionRatio >= 0.35) this.visibleVideoCards.add(target)
              else {
                this.visibleVideoCards.delete(target)
                target.querySelector('video')?.pause()
              }
            })
            resumeVisible()
          }, { threshold: [0, 0.35] })
          this.querySelectorAll('[data-ugc-video]').forEach((card) => this.videoObserver.observe(card))
          this.resizeObserver = new ResizeObserver(updateButtons)
          this.resizeObserver.observe(this.viewport)
          updateButtons()
          if (this.autoplayEnabled && !this.reducedMotion) this.setupFlow(signal)
        }

        setupMixedDragging(signal) {
          let pointerId = null
          let startX = 0
          let previousX = 0
          let didDrag = false
          let suppressClickUntil = 0
          this.viewport.addEventListener('dragstart', this.preventNativeDrag, { signal })
          this.viewport.addEventListener('pointerdown', (event) => {
            // Touch keeps native swipe, momentum, and vertical page scrolling.
            if (event.pointerType !== 'mouse' || event.button !== 0) return
            pointerId = event.pointerId
            startX = previousX = event.clientX
            didDrag = false
            suppressClickUntil = 0
          }, { signal })
          window.addEventListener('pointermove', (event) => {
            if (event.pointerId !== pointerId) return
            if (!didDrag && Math.abs(event.clientX - startX) < 5) return
            event.preventDefault()
            if (!didDrag) {
              didDrag = true
              this.viewport.setPointerCapture(pointerId)
              this.viewport.classList.add('is-dragging')
            }
            const nextPosition = this.viewport.scrollLeft + previousX - event.clientX
            previousX = event.clientX
            if (this.flowStride) {
              this.flowPosition = nextPosition
              this.normalizeFlow()
            } else {
              this.viewport.scrollLeft = nextPosition
            }
          }, { passive: false, signal })
          const finishDrag = (event) => {
            if (pointerId === null || (event.pointerId !== undefined && event.pointerId !== pointerId)) return
            const releasedPointer = pointerId
            pointerId = null
            this.viewport.classList.remove('is-dragging')
            if (didDrag) suppressClickUntil = performance.now() + 400
            if (this.viewport.hasPointerCapture(releasedPointer)) this.viewport.releasePointerCapture(releasedPointer)
          }
          for (const type of ['pointerup', 'pointercancel', 'blur']) {
            window.addEventListener(type, finishDrag, { signal })
          }
          this.viewport.addEventListener('lostpointercapture', finishDrag, { signal })
          this.viewport.addEventListener('click', (event) => {
            if (performance.now() >= suppressClickUntil) return
            event.preventDefault()
            event.stopImmediatePropagation()
          }, { capture: true, signal })
        }

        ensureFlowCards() {
          if (!this.autoplayEnabled || this.reducedMotion || !this.cards.length) return
          const stride = this.step()
          if (!stride || !this.viewport.clientWidth) return
          // Keep the visible row plus recycling space on both sides scrollable.
          const minimumCards = Math.ceil(this.viewport.clientWidth / stride) + 4
          if (this.track.children.length >= minimumCards) return
          // Repeat complete cycles in their current order, including after a resize.
          const cycle = [...this.track.children].slice(-this.cards.length)
          while (this.track.children.length < minimumCards) {
            cycle.forEach((card) => {
              const clone = card.cloneNode(true)
              clone.removeAttribute('data-ugc-card')
              clone.removeAttribute('data-shopify-editor-block')
              clone.removeAttribute('id')
              clone.setAttribute('data-ugc-flow-clone', '')
              clone.setAttribute('aria-hidden', 'true')
              clone.querySelectorAll('[id], [data-shopify-editor-block]').forEach((element) => {
                element.removeAttribute('id')
                element.removeAttribute('data-shopify-editor-block')
              })
              clone.querySelectorAll('button, a, [tabindex]').forEach((element) => element.setAttribute('tabindex', '-1'))
              clone.querySelectorAll('video').forEach((video) => video.remove())
              clone.querySelectorAll('[data-ugc-video]').forEach((videoCard) => {
                videoCard.classList.remove('is-video-started', 'is-video-playing', 'needs-video-play')
                delete videoCard.dataset.playPending
                videoCard.querySelector('.ws-ugc-card__error').hidden = true
              })
              this.track.append(clone)
              clone.querySelectorAll('[data-ugc-video]').forEach((videoCard) => this.videoObserver?.observe(videoCard))
            })
          }
          if (this.deferredImageObserver) {
            this.deferredImageObserver.disconnect()
            this.setupDeferredImages()
          }
        }

        setupFlow(signal) {
          this.classList.add('ws-ugc--flow')
          this.flowPosition = this.viewport.scrollLeft
          this.flowStride = this.step()
          this.flowVisible = false
          this.flowHolding = false
          this.flowInteracting = false
          this.flowFocused = false
          this.normalizeFlow()
          const pauseInteraction = () => {
            this.flowInteracting = true
            this.stopFlow()
            window.clearTimeout(this.flowResumeTimer)
          }
          const resumeLater = () => {
            window.clearTimeout(this.flowResumeTimer)
            if (this.flowHolding) return
            this.flowResumeTimer = window.setTimeout(() => {
              this.flowInteracting = false
              this.startFlow()
            }, 1400)
          }
          this.viewport.addEventListener('pointerdown', () => {
            this.flowHolding = true
            pauseInteraction()
          }, { passive: true, signal })
          window.addEventListener('pointerup', () => {
            this.flowHolding = false
            resumeLater()
          }, { passive: true, signal })
          this.viewport.addEventListener('pointercancel', (event) => {
            if (event.pointerType === 'touch') return
            this.flowHolding = false
            resumeLater()
          }, { passive: true, signal })
          const releaseInteraction = () => {
            this.flowHolding = false
            resumeLater()
          }
          this.viewport.addEventListener('lostpointercapture', releaseInteraction, { signal })
          window.addEventListener('blur', releaseInteraction, { signal })
          this.viewport.addEventListener('touchstart', () => {
            this.flowHolding = true
            pauseInteraction()
          }, { passive: true, signal })
          for (const type of ['touchend', 'touchcancel']) {
            window.addEventListener(type, () => {
              this.flowHolding = false
              resumeLater()
            }, { passive: true, signal })
          }
          this.viewport.addEventListener('scroll', () => {
            if (this.flowInteracting) resumeLater()
          }, { passive: true, signal })
          for (const type of ['wheel', 'keydown']) {
            this.viewport.addEventListener(type, () => {
              pauseInteraction()
              resumeLater()
            }, { passive: true, signal })
          }
          this.addEventListener('focusin', (event) => {
            this.flowFocused = event.target.matches(':focus-visible')
            if (this.flowFocused) this.stopFlow()
          }, { signal })
          this.addEventListener('focusout', () => {
            this.flowFocused = false
            this.startFlow()
          }, { signal })
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.stopFlow()
            else this.startFlow()
          }, { signal })
          window.addEventListener('pagehide', () => this.stopFlow(), { signal })
          window.addEventListener('pageshow', () => this.startFlow(), { signal })
          this.flowObserver = new IntersectionObserver(([entry]) => {
            this.flowVisible = entry.isIntersecting
            if (this.flowVisible) this.startFlow()
            else this.stopFlow()
          }, { threshold: 0.01 })
          this.flowObserver.observe(this.viewport)
        }

        normalizeFlow() {
          const stride = this.flowStride
          if (!stride || this.track.children.length < 4) return
          while (this.flowPosition < stride * 2) {
            const card = this.track.lastElementChild
            card.querySelector('video')?.pause()
            this.track.prepend(card)
            this.flowPosition += stride
          }
          while (this.flowPosition >= stride * 3) {
            const card = this.track.firstElementChild
            card.querySelector('video')?.pause()
            this.track.append(card)
            this.flowPosition -= stride
          }
          this.viewport.scrollLeft = this.flowPosition
        }

        startFlow() {
          if (this.flowFrame || !this.isConnected || !this.flowVisible || document.hidden ||
              this.flowInteracting || this.flowFocused) return
          this.flowStride = this.step()
          this.flowPosition = this.viewport.scrollLeft
          this.normalizeFlow()
          this.flowTime = performance.now()
          const tick = (now) => {
            this.flowPosition += Math.min(40, now - this.flowTime) * this.speed / 1000
            this.flowTime = now
            this.normalizeFlow()
            this.flowFrame = requestAnimationFrame(tick)
          }
          this.flowFrame = requestAnimationFrame(tick)
        }

        stopFlow() {
          cancelAnimationFrame(this.flowFrame)
          this.flowFrame = null
        }

        playCard(card, button, automatic = false) {
          let video = card.querySelector('video')
          if (video && (!video.paused || card.dataset.playPending === 'true')) return
          const errorLabel = card.querySelector('.ws-ugc-card__error')
          errorLabel.hidden = true
          if (!video) {
            video = document.createElement('video')
            video.className = 'ws-ugc-card__video'
            video.controls = false
            video.playsInline = true
            video.muted = true
            video.defaultMuted = true
            video.loop = true
            video.setAttribute('muted', '')
            video.setAttribute('playsinline', '')
            video.preload = 'none'
            video.poster = card.dataset.videoPoster
            video.setAttribute('aria-label', button.getAttribute('aria-label'))
            video.src = window.matchMedia('(max-width: 749px)').matches ? card.dataset.videoMobileSrc : card.dataset.videoSrc
            const { signal } = this.mediaAbort
            video.addEventListener('play', () => {
              card.classList.add('is-video-started', 'is-video-playing')
              card.classList.remove('needs-video-play')
              if (document.hidden || !this.visibleVideoCards.has(card)) video.pause()
            }, { signal })
            video.addEventListener('pause', () => {
              card.classList.remove('is-video-playing')
            }, { signal })
            video.addEventListener('error', () => {
              card.classList.remove('is-video-started', 'is-video-playing')
              card.classList.add('needs-video-play')
              video.remove()
              errorLabel.hidden = false
            }, { signal })
            card.prepend(video)
          }
          card.dataset.playPending = 'true'
          video.play().catch((error) => {
            if (error.name === 'AbortError') return
            card.classList.remove('is-video-playing')
            card.classList.add('needs-video-play')
            if (!automatic && error.name !== 'NotAllowedError') errorLabel.hidden = false
          }).finally(() => { delete card.dataset.playPending })
        }

        handlePointerDown = (event) => {
          if (event.button !== undefined && event.button !== 0) return
          this.cancelMomentum()
          window.clearTimeout(this.interactionResumeTimer)
          this.pause('pointer')
          this.dragging = true
          this.dragAxis = null
          this.didDrag = false
          this.dragStartX = event.clientX
          this.dragStartY = event.clientY
          this.lastPointerX = event.clientX
          this.lastPointerTime = performance.now()
          this.dragVelocity = 0
          this.viewport.classList.add('is-dragging')
          this.viewport.setPointerCapture?.(event.pointerId)
        }

        handlePointerMove = (event) => {
          if (!this.dragging) return

          const distanceX = event.clientX - this.dragStartX
          const distanceY = event.clientY - this.dragStartY
          if (!this.dragAxis) {
            if (Math.abs(distanceX) < 5 && Math.abs(distanceY) < 5) return
            this.dragAxis = Math.abs(distanceX) >= Math.abs(distanceY) ? 'horizontal' : 'vertical'
          }
          if (this.dragAxis !== 'horizontal') return

          event.preventDefault()
          const delta = this.lastPointerX - event.clientX
          const now = performance.now()
          const elapsed = Math.max(1, now - this.lastPointerTime)
          this.lastPointerX = event.clientX
          this.lastPointerTime = now
          this.dragVelocity = this.dragVelocity * 0.55 + (delta / elapsed) * 0.45
          this.didDrag = this.didDrag || Math.abs(distanceX) > 5
          this.setStaticPosition(this.position + delta)
        }

        handlePointerEnd = (event) => {
          if (!this.dragging) return
          this.dragging = false
          this.viewport.classList.remove('is-dragging')
          if (this.viewport.hasPointerCapture?.(event.pointerId)) {
            this.viewport.releasePointerCapture(event.pointerId)
          }
          if (this.didDrag && this.contains(document.activeElement)) {
            document.activeElement.blur()
          }
          const releaseVelocity =
            performance.now() - this.lastPointerTime > 120 ? 0 : this.dragVelocity
          const momentumStarted =
            event.type !== 'pointercancel' &&
            this.didDrag &&
            this.dragAxis === 'horizontal' &&
            this.startMomentum(releaseVelocity)
          if (!momentumStarted) {
            window.clearTimeout(this.interactionResumeTimer)
            this.interactionResumeTimer = window.setTimeout(
              () => this.resume('pointer'),
              this.didDrag ? 180 : 0
            )
          }
          if (this.didDrag) {
            window.setTimeout(() => {
              this.didDrag = false
            }, 0)
          }
        }

        preventNativeDrag = (event) => {
          event.preventDefault()
        }

        preventClickAfterDrag = (event) => {
          if (!this.didDrag) return
          event.preventDefault()
          event.stopImmediatePropagation()
          this.didDrag = false
        }

        cancelMomentum() {
          if (!this.momentumAnimation) return
          const currentPosition = this.readPosition()
          this.momentumAnimation.cancel()
          this.momentumAnimation = null
          this.pauseReasons.delete('momentum')
          this.setStaticPosition(currentPosition)
        }

        startMomentum(velocity) {
          if (!this.loopSpan || Math.abs(velocity) < 0.08) return false

          const maximumDistance = this.viewport.clientWidth * 1.75
          const distance = Math.max(
            -maximumDistance,
            Math.min(maximumDistance, velocity * this.swipeMomentum)
          )
          if (Math.abs(distance) < 16) return false

          this.pause('momentum')
          let startPosition = this.position
          let targetPosition = startPosition + distance
          if (targetPosition < 0) {
            startPosition += this.loopSpan
            targetPosition += this.loopSpan
          }

          this.track.classList.remove('is-autoplaying')
          this.track.style.transform = `translate3d(${-startPosition}px, 0, 0)`
          this.momentumAnimation = this.track.animate(
            [
              { transform: `translate3d(${-startPosition}px, 0, 0)` },
              { transform: `translate3d(${-targetPosition}px, 0, 0)` }
            ],
            {
              duration: Math.min(560, Math.max(260, this.swipeMomentum)),
              easing: 'cubic-bezier(0.12, 0.7, 0.2, 1)',
              fill: 'forwards'
            }
          )
          this.momentumAnimation.finished
            .then(() => {
              this.position = this.normalize(targetPosition)
              this.setStaticPosition(this.position)
              this.momentumAnimation?.cancel()
              this.momentumAnimation = null
              this.resume('pointer')
              this.resume('momentum')
            })
            .catch(() => {})
          return true
        }

        handleKeyDown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
          event.preventDefault()
          this.move(event.key === 'ArrowLeft' ? -1 : 1)
        }

        createLoop() {
          this.clones = this.cards.map((card) => {
            const clone = card.cloneNode(true)
            clone.removeAttribute('data-ugc-card')
            clone.removeAttribute('data-shopify-editor-block')
            clone.removeAttribute('id')
            clone.setAttribute('aria-hidden', 'true')
            clone.setAttribute('inert', '')
            clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'))
            clone.querySelectorAll('img').forEach((image) => {
              image.loading = 'lazy'
              image.decoding = 'async'
              image.fetchPriority = 'low'
            })
            this.track.append(clone)
            return clone
          })
        }

        setupDeferredImages() {
          const deferredImages = [...this.querySelectorAll('img[data-ws-ugc-src]')]
          if (!deferredImages.length) return

          const hydrateImages = () => {
            deferredImages.forEach((image) => {
              image.srcset = image.dataset.wsUgcSrcset
              image.src = image.dataset.wsUgcSrc
              image.removeAttribute('data-ws-ugc-srcset')
              image.removeAttribute('data-ws-ugc-src')
            })
            this.deferredImageObserver?.disconnect()
          }

          if (!('IntersectionObserver' in window)) {
            hydrateImages()
            return
          }

          this.deferredImageObserver = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) hydrateImages()
            },
            { rootMargin: '500px 0px' }
          )
          this.deferredImageObserver.observe(this)
        }

        setupVisibilityObserver() {
          if (!('IntersectionObserver' in window)) {
            this.resume('offscreen')
            return
          }

          this.visibilityObserver = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) this.resume('offscreen')
              else this.pause('offscreen')
            },
            { threshold: 0.01 }
          )
          this.visibilityObserver.observe(this)
        }

        measureLoop() {
          const firstCard = this.cards[0]
          const firstClone = this.clones?.[0]
          if (!firstCard || !firstClone) return

          const wasRunning = this.track.classList.contains('is-autoplaying')
          const previousSpan = this.loopSpan || 0
          if (wasRunning) this.stop()
          const progress = previousSpan ? this.position / previousSpan : 0
          this.loopSpan = firstClone.offsetLeft - firstCard.offsetLeft
          this.position = this.loopSpan * progress
          this.setAnimationProperties()
          if (wasRunning) this.start()
          else this.setStaticPosition(this.position)
        }

        step() {
          const first = this.cards[0]
          if (!first) return 0
          const styles = getComputedStyle(this.querySelector('.ws-ugc__track'))
          return first.getBoundingClientRect().width + Number.parseFloat(styles.gap || 0)
        }

        move(direction) {
          const step = this.step()
          if (!step || !this.loopSpan) return

          this.pause('manual')
          this.manualAnimation?.cancel()

          let startPosition = this.position
          if (direction < 0 && startPosition < step) {
            startPosition += this.loopSpan
          } else if (direction > 0 && startPosition >= this.loopSpan - step) {
            startPosition -= this.loopSpan
          }
          const targetPosition = startPosition + step * direction
          this.setStaticPosition(startPosition)

          this.manualAnimation = this.track.animate(
            [
              { transform: `translate3d(${-startPosition}px, 0, 0)` },
              { transform: `translate3d(${-targetPosition}px, 0, 0)` }
            ],
            {
              duration: 320,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'forwards'
            }
          )
          this.manualAnimation.finished
            .then(() => {
              this.position = this.normalize(targetPosition)
              this.setStaticPosition(this.position)
              this.manualAnimation?.cancel()
              this.manualAnimation = null
              this.resume('manual')
            })
            .catch(() => {})
        }

        start() {
          if (!this.autoplayEnabled || this.reducedMotion || document.hidden || this.pauseReasons.size || !this.loopSpan) return
          this.position = this.normalize(this.position)
          this.setAnimationProperties()
          this.track.style.transform = ''
          this.track.classList.add('is-autoplaying')
        }

        stop() {
          if (this.track.classList.contains('is-autoplaying')) {
            this.position = this.readPosition()
          }
          this.track.classList.remove('is-autoplaying')
          this.track.style.transform = `translate3d(${-this.position}px, 0, 0)`
        }

        pause(reason) {
          this.pauseReasons.add(reason)
          this.stop()
        }

        resume(reason) {
          this.pauseReasons.delete(reason)
          this.start()
        }

        normalize(position) {
          if (!this.loopSpan) return Math.max(0, position || 0)
          return ((position % this.loopSpan) + this.loopSpan) % this.loopSpan
        }

        readPosition() {
          const transform = getComputedStyle(this.track).transform
          if (!transform || transform === 'none') return this.normalize(this.position)

          try {
            const Matrix = window.DOMMatrixReadOnly || window.WebKitCSSMatrix
            const matrix = new Matrix(transform)
            return this.normalize(-matrix.m41)
          } catch {
            return this.normalize(this.position)
          }
        }

        setStaticPosition(position) {
          this.position = this.normalize(position)
          this.track.classList.remove('is-autoplaying')
          this.track.style.transform = `translate3d(${-this.position}px, 0, 0)`
        }

        setAnimationProperties() {
          if (!this.loopSpan || !this.speed) return
          this.track.style.setProperty('--ws-ugc-loop-distance', `${-this.loopSpan}px`)
          this.track.style.setProperty('--ws-ugc-duration', `${this.loopSpan / this.speed}s`)
          this.track.style.setProperty('--ws-ugc-delay', `${-this.position / this.speed}s`)
        }
      }
    )
  }

  const setupCompactReviews = () => {
    const labels = document.querySelector('.ws-ugc[data-reviews-preview-count]')
    if (!labels) return

    const desktopPreviewCount = Number(labels.dataset.reviewsPreviewCount) || 3
    const mobilePreviewCount = Number(labels.dataset.reviewsPreviewCountMobile) || 2
    const previewCount = window.matchMedia('(max-width: 899px)').matches ? mobilePreviewCount : desktopPreviewCount
    const showLabel = labels.dataset.reviewsShowLabel || 'All reviews'
    const hideLabel = labels.dataset.reviewsHideLabel || 'Show less'

    document.querySelectorAll('.jdgm-widget.jdgm-widget-revamp').forEach((widget) => {
      const list = widget.querySelector('.jdgm-review-list')
      if (!list) return

      widget.classList.add('ws-reviews-compact')
      const expanded = widget.classList.contains('ws-reviews-expanded')
      const items = [...list.querySelectorAll(':scope > .jm-review-item')]
      items.forEach((item, index) => {
        item.hidden = !expanded && index >= previewCount
      })

      let button = widget.querySelector('[data-ws-reviews-toggle]')
      if (!button) {
        button = document.createElement('button')
        button.type = 'button'
        button.className = 'ws-reviews-toggle'
        button.dataset.wsReviewsToggle = ''
        button.addEventListener('click', () => {
          widget.classList.toggle('ws-reviews-expanded')
          setupCompactReviews()
        })
        const target = widget.querySelector('.jm-review-widget__header-and-body') || widget
        target.append(button)
      }

      const hasMore = items.length > previewCount || Boolean(widget.querySelector('.jm-pagination-controls'))
      button.hidden = !hasMore
      const buttonLabel = expanded ? hideLabel : showLabel
      if (button.textContent !== buttonLabel) button.textContent = buttonLabel
      button.setAttribute('aria-expanded', String(expanded))
    })
  }

  let compactReviewsTimer
  const scheduleCompactReviews = () => {
    window.clearTimeout(compactReviewsTimer)
    compactReviewsTimer = window.setTimeout(setupCompactReviews, 80)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCompactReviews, { once: true })
  } else {
    scheduleCompactReviews()
  }

  window.addEventListener('resize', scheduleCompactReviews, { passive: true })

  new MutationObserver(scheduleCompactReviews).observe(document.documentElement, {
    childList: true,
    subtree: true
  })

  } catch(e) { console.error(e); }
})();
})();
